export default {
  authenticationState: {
    __typename: "AuthenticationState",
    authenticated: false,
    selectedProject: null,
    needsToOnboard: false,
    uid: null,
    darkMode: null
  },
};
